import { faArrowUpFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useDerivative from '../../hooks/useDerivative';
import settings from '../../settings';

const PwaInstallBanner = () => {
  const { t } = useTranslation();
  const { className, pwaBanner } = useDerivative();
  const [showBanner, setShowBanner] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIos, setIsIos] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [fallbackSrc, setFallbackSrc] = useState('');

  useEffect(() => {
    if (!pwaBanner) {
      return;
    }
    const userAgent = window.navigator.userAgent.toLowerCase();
    const mobile = /iphone|ipad|ipod|android/.test(userAgent);
    setIsMobile(mobile);

    const isIosDevice = /iphone|ipad|ipod/.test(userAgent);
    setIsIos(isIosDevice);

    const inStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    setIsStandalone(inStandalone);

    // Android support for install prompt
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault(); // Prevent native banner
      setDeferredPrompt(e);
      if (mobile && !inStandalone) {
        setShowBanner(true);
      }
    });

    // Fallback for iOS (no install prompt)
    if (mobile && isIosDevice && !inStandalone) {
      setShowBanner(true);
    }
  }, [pwaBanner]);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const result = await deferredPrompt.userChoice;
      console.log('User choice:', result.outcome);
      setDeferredPrompt(null);
      setShowBanner(false);
    }
  };

  const fallbackLogo = () => {
    if (!fallbackSrc) {
      setFallbackSrc('/applogo_192x192.png');
    } else {
      setShowBanner(false);
    }
  };

  if (!pwaBanner || !isMobile || isStandalone || !showBanner) return null;

  const imageSrc = `${settings.cdn}/${className}/applogo_192x192.png`;

  return (
    <div className="PwaInstallBanner-banner">
      <div className="PwaInstallBanner-icon">
        <img
          src={fallbackSrc || imageSrc}
          alt="AppLogo"
          onError={() => fallbackLogo()}
        />
      </div>
      <div className="PwaInstallBanner-text">
        {isIos ? (
          <>
            {t('global.pwaBanner.ios.textA')}
            <FontAwesomeIcon
              className="PwaInstallBanner-shareIcon"
              icon={faArrowUpFromSquare}
            />
            {t('global.pwaBanner.ios.textB')}
          </>
        ) : (
          <>
            {t('global.pwaBanner.android.text')}
            <button
              className="PwaInstallBanner-installBtn"
              onClick={handleInstallClick}
            >
              {t('global.pwaBanner.android.button')}
            </button>
          </>
        )}
      </div>
      <button
        onClick={() => setShowBanner(false)}
        className="PwaInstallBanner-closeBtn"
      >
        ×
      </button>
    </div>
  );
};

PwaInstallBanner.propTypes = {};

export default PwaInstallBanner;
